import { useMemo } from "react";

import { cn } from "@/lib/utils";

import DOMPurify from "dompurify";
import parse, { HTMLReactParserOptions } from "html-react-parser";
import MarkdownIt from "markdown-it";

interface MarkdownProps {
  content: string;
  className?: string;
  replace?: HTMLReactParserOptions["replace"];
}

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
});

export function Markdown({ content, className, replace }: MarkdownProps) {
  const reactContent = useMemo(() => {
    const safeHtml = DOMPurify.sanitize(md.render(content));
    return parse(safeHtml, replace ? { replace } : undefined);
  }, [content, replace]);

  return (
    <div className={cn("markdown-it max-w-none", className)}>
      {reactContent}
    </div>
  );
}
